import { hasToken } from "../cardComponents/utils";

/**
 * Devuelve los bankValues activos desde la config de BD.
 */
export const getEnabledWompiBanks = (tokenizedBanks = []) => {
  return tokenizedBanks
    .filter((bank) => bank.active)
    .map((bank) => bank.value);
};

/**
 * Resuelve el paso inicial según ruta, banco guardado, token y config de BD.
 */
export const resolveInitialStep = (pathname, bank, tokenIdWompi, tokenizedBanks = []) => {
  // Sin banco guardado → paso 1
  if (!bank) return 1;

  // Con token → siempre datos manuales
  if (hasToken(tokenIdWompi)) return 4;

  // Sin token: verificar si el banco está activo en BD
  const enabledBanks = getEnabledWompiBanks(tokenizedBanks);

  if (enabledBanks.includes(String(bank))) return 2;

  //otros bancos = tarjetas de débito y crédito.
  if (enabledBanks.includes(String(-1)) && bank !== 21 && bank !== 30 && bank !== 31) return 3;

  return 4; // fallback
};